/**
 * Helper function to get the product id of the add to sub button
 * @param {HTMLElement} element
 */
const findProductId = (element) => {
  let parent = element.parentElement;

  while (
    !parent.querySelector("[data-product-id]") &&
    parent !== document.body
  ) {
    parent = parent.parentElement;
  }

  return parent
    .querySelector("[data-product-id]")
    .getAttribute("data-product-id");
};

const localStorageKey = "leader-subscriptions";
var SubscriptionBanner = class extends HTMLElement {
  constructor() {
    super();

    this.init();
    this.querySelector("button#cancel").addEventListener(
      "click",
      this.onCancel
    );
  }

  currentSubscription = () => window.localStorage.getItem(localStorageKey);

  init = () => {
    this.toggle(this.currentSubscription());
    // Add an event listener for cross tab communication
    window.addEventListener("storage", this.storageHandler);
  };

  onCancel = async () => {
    window.localStorage.removeItem(localStorageKey);
    this.toggle();
    window.location.reload();
  };

  /**
   *
   * @param {StorageEvent} e
   * @returns
   */
  storageHandler = (e) => {
    if (e.key !== localStorageKey) return;
    this.toggle(e.newValue);
  };

  /**
   *
   * @param {string | undefined} [storageSubscription]
   */
  toggle = (storageSubscription) => {
    this.setAttribute("data-active", !!storageSubscription ? "true" : "false");
    if (storageSubscription) {
      const [subId, frequency] = storageSubscription.split("-");
      this.frequency = frequency;
      this.subId = subId;
      storageSubscription && this.initAtcButton();
      storageSubscription && this.selectFrequencies();
      this.querySelector("#subId").textContent = this.subId || "";
    }
  };

  selectFrequencies = () => {
    const frequencies = Array.from(
      document.querySelectorAll("input[data-text]")
    );
    setTimeout(() => {
      if (frequencies.length) {
        frequencies.forEach((frequency) => {
          if (frequency.dataset.text.toLowerCase().trim() === this.frequency.toLowerCase().trim()) {
            frequency.click();
          } else {
            frequency.setAttribute("disabled", "true");
          }
        });
      }
    }, 200);
  };

  initAtcButton = () => {
    const buttons = this.atcButton();
    if (!buttons.length) return;
    buttons.forEach((button) => {
      try {
        button.innerHTML = "";
        const text = document.createElement("span");
        text.textContent = "Ajouter le produit à l'abonnement";
        button.appendChild(text);
        button.removeAttribute("type");
        button.removeAttribute("disabled");
        button.removeAttribute("data-action");
        button.removeAttribute("data-secondary-action");
        button.addEventListener("click", this.onAddProduct);
      } catch (error) {}
    });
  };

  getButton = (element) => {
    let button = element;

    while (button.tagName !== "BUTTON" && button) {
      console.log(button.tagName);
      button = button.parentElement;
    }

    return button;
  };

  onAddProduct = async (e) => {
    e.stopPropagation();
    e.preventDefault();
    const product_id = findProductId(e.target);
    const button = this.getButton(e.target);
    button.setAttribute("data-loading", "true");

    console.log({ product_id, target: e.target, button });

    const res = await authFetch(
      "add-product-to-existing-sub",
      {
        subscription_id: this.subId,
        product_id,
      },
      "PATCH"
    );
    console.log(res);

    this.setAttribute("data-loading", "false");
    window.location = `https://${window.Shopify.shop}/pages/compte-abonnement?id=${this.subId}`;
    window.localStorage.removeItem(localStorageKey);
  };

  atcButton = () => {
    const atcButton = document.querySelector(
      ".product__payment-wrapper button"
    );
    const collectionButtons = document.querySelectorAll(
      ".c-product-card__quick-view"
    );
    return [atcButton, ...Array.from(collectionButtons)];
  };
};

window.customElements.define("subscriptions-banner", SubscriptionBanner);

var AddToSubscriptionButton = class extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", this.onClick);
  }

  onClick = () => {
    window.localStorage.setItem(
      localStorageKey,
      `${searchParams().id}-${this.getAttribute("data-lp-frequency")}`
    );
    //  console.log(
    //   `${searchParams().id}-${this.getAttribute("data-lp-frequency")}`
    // );
    window.location = `https://${window.Shopify.shop}/collections/abonnement`;
  };
};

window.customElements.define(
  "add-to-subscription-button",
  AddToSubscriptionButton
);
